import * as React from "react";
const SvgTwitter = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 18, fill: "none", viewBox: "0 0 20 18", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#000", d: "m.047 0 7.425 9.928L0 18h1.682l6.542-7.067L13.509 18h5.723L11.389 7.514 18.344 0h-1.682l-6.025 6.509L5.77 0zM2.52 1.239h2.629l11.61 15.522h-2.63z" }));
export default SvgTwitter;
